import { render } from "./Vacatures.vue?vue&type=template&id=2aea5fc6&scoped=true"
import script from "./Vacatures.vue?vue&type=script&lang=js"
export * from "./Vacatures.vue?vue&type=script&lang=js"

import "./Vacatures.vue?vue&type=style&index=0&id=2aea5fc6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2aea5fc6"]])

export default __exports__